import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { logInterface } from 'src/app/util/interfaces/log.interface';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';
import { environment } from 'src/environments/environment';
@Injectable({
	providedIn: 'root',
})
export class RequestPageTabAcompanhamentoService {
	private http = inject(HttpClient);
	private authLoginService = inject(AuthLoginService);

	private getAvailableStatusUrl = environment.baseApiUrl + 'request/{idRequest}/status';
	private getAllStatusUrl = environment.baseApiUrl + 'request/status';
	private getLogFile = environment.baseApiUrl + 'request/fileAttach/{fileName}';
	private superUpdateLogUrl = environment.baseApiUrl + 'super/update/log/{idLog}';

	constructor() {}

	getAvailableStatus(idRequest: string): Observable<statusInterface[]> {
		const getAvailableStatusUrl = this.getAvailableStatusUrl.replace('{idRequest}', idRequest.toString());
		return this.http.get<JSON>(getAvailableStatusUrl, { headers: this.authLoginService.getHttpHeaders() }).pipe(
			map((statusRes: any) => {
				const newAvailableStatus: statusInterface[] = [];

				for (const status of statusRes) {
					const newStatus: statusInterface = {
						status: status.status,
						label: status.label,
					};
					newAvailableStatus.push(newStatus);
				}

				return newAvailableStatus;
			})
		);
	}

	getAllStatus(): Observable<statusInterface[]> {
		return this.http.get<statusInterface[]>(this.getAllStatusUrl, { headers: this.authLoginService.getHttpHeaders() });
	}

	getFile(fileName: string): Observable<mspFileInterface> {
		const getLogFile = this.getLogFile.replace('{fileName}', fileName);
		return this.http.get(getLogFile, { headers: this.authLoginService.getHttpHeaders() }).pipe(
			map((fileRes: any) => {
				const newMspFile: mspFileInterface = {
					content: fileRes.content,
					name: fileRes.name,
					mimeType: fileRes.mimeType,
					extension: fileRes.extension,
					size: 0,
					file_path: '',
				};

				return newMspFile;
			})
		);
	}

	superUpdateLog(superNewLog: logInterface): Observable<JSON> {
		const body = {
			analyst: superNewLog.analyst,
			duration: superNewLog.duration,
			notes: superNewLog.notes,
			status: superNewLog.status,
			log_date: superNewLog.log_date,
		};
		const superUpdateLogUrl = this.superUpdateLogUrl.replace('{idLog}', superNewLog.idLog);
		return this.http.put<JSON>(superUpdateLogUrl, body, { headers: this.authLoginService.getHttpHeaders() });
	}
}
